import React, { useState, useEffect } from 'react';
import { Alert, Col, Container, Dropdown, DropdownButton, Row, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import '../../../styles/RegDashboard.css';
import { HHIEButton } from '../../utility/HHIEButton';
import Loading from '../../utility/Loading';
import { AdminDashAccountsTable } from './AdminDashAccountsTable';
import { AdminDashFilters } from './AdminDashFilters';
import { AdminDashSearch } from './AdminDashSearch';
import ManuallyOnboard from '../onboarding/ManuallyOnboard';

export function AdminRegDashboard() {
    const [year, setYear] = useState(0);
    const [accounts, setAccounts] = useState(null);
    const [filteredLimitedAccounts, setFilteredLimitedAccounts] = useState(null);
    const [loading, setLoading] = useState(true);
    const [complete, setComplete] = useState(false);
    const [incomplete, setIncomplete] = useState(false);
    const [active, setActive] = useState(true);
    const [inactive, setInactive] = useState(false);
    const [yearArray, setYearArray] = useState(false);
    const [filteredLength, setFilteredLength] = useState(0);
    const [search, setSearch] = useState(false);
    const [searchValue, setSearchValue] = useState("");

    const [limit, setLimit] = useState(10);
    const [pages, setPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [goToLast, setGoToLast] = useState(false);

    const [user, setUser] = useState(null);

    useEffect(() => {
        // extract from storage one time, save string into a const variable since it should not change.
        const userString = sessionStorage.getItem("user");
        // parse out immutable userString from storage
        const currentUser = JSON.parse(userString);
        setUser(currentUser);

        const IsRegistrationFeatureOn = async () => {
            var regIsOn = false;
            const result = await fetch('api/admin/GetFeatures')
                .then(async (response) => {
                    try {
                        return await response.json()
                            .then(json => {
                                if (json.errors !== null && json.errors !== "") alert(json.errors)
                                return json.message;
                            });
                    }
                    catch (ex) {
                        return console.log("regFeature", ex);
                    }
                })
                .catch(ex => {
                    console.log(ex);
                });
            for (var feature of result) {
                if (feature.name === "registration") {
                    regIsOn = feature.value;
                }
            }
            if (!regIsOn) {
                window.location.href = '/logout';
            }
        };
        IsRegistrationFeatureOn();
        fetch('api/registration/RetrieveAllAccounts')
            .then((response) => {
                response.json()
                    .then((accts) => {
                        if (accts.errors !== null && accts.errors !== "") alert(accts.errors)
                        setAccounts(accts.message);
                        setLoading(false);
                    })
                    .catch((error) => {
                        console.log("json conversion error: " + error);
                    })
            })
            .catch((error) => {
                console.log("All Accounts response error: " + error);
            });
    }, [])

    useEffect(() => {
        if (accounts) {
            var yearList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
            var finalYearList = [];
            for (var yr of yearList) {
                var newestDate = new Date();
                newestDate.setFullYear(newestDate.getFullYear() - yr);

                for (var acct of accounts) {
                    var createdDate = new Date(acct.createdDate.split("T")[0]);
                    if (newestDate.getFullYear() === createdDate.getFullYear() || (yr === 10 && createdDate.getFullYear() <= newestDate.getFullYear())) {
                        finalYearList.push({ value: yr });
                        break;
                    }
                }
                finalYearList.sort((a, b) => a.value - b.value);
                setYearArray(finalYearList);
                setYear(finalYearList.length >= 1 ? finalYearList[0].value : 0);
            }
        }
    }, [accounts])

    useEffect(() => {
        var filtered = accounts;
        if (accounts) {
            if (search && searchValue && searchValue !== "") {
                filtered = accounts.filter(searchAcct => {

                    var searchedValue = searchValue;
                    var legalNameOptions = searchedValue.split(" ");
                    for (var name of legalNameOptions) {
                        if (!searchAcct.legalName.toUpperCase().includes(name.toUpperCase())) {
                            return false;
                        }
                    }
                    return true;
                })
            }

            else if (year >= 0 && year <= 10) {
                filtered = accounts.filter(account => {
                    var createdDateString = account.createdDate.split("T")[0];
                    var createdDate = new Date(createdDateString);
                    var newestDate = new Date();
                    newestDate.setFullYear(newestDate.getFullYear() - year);
                    if ((newestDate.getFullYear() === createdDate.getFullYear())
                        || (year === 10 && createdDate.getFullYear() <= newestDate.getFullYear())) {
                        return true;
                    }
                    return false;
                });
                filtered = filtered.filter(account => {
                    if (!active && !inactive) {
                        return true;
                    }
                    if (active && account.status === "Active") {
                        return true;
                    }
                    if (inactive && account.status === "Inactive") {
                        return true;
                    }
                    return false;
                })
                filtered = filtered.filter(account => {
                    var regComplete = checkAccountComplete(account);

                    if (!complete && !incomplete) {
                        return true;
                    }
                    if (complete && regComplete) {
                        return true;
                    }
                    if (incomplete && !regComplete) {
                        return true;
                    }
                    return false;
                });
            }
            setFilteredLength(filtered.length);

            var pgs = (Math.ceil((filtered.length) / limit));
            setPages(pgs);
            var currentPg = (goToLast)?(pgs-1):currentPage;
            setCurrentPage(currentPg);
            var sliceStart = parseInt(currentPage) * parseInt(limit);
            var sliceEnd = (currentPage * limit + limit < filtered.length) ? currentPage * limit + limit : filtered.length;
            let filteredLimited = filtered.slice(sliceStart, sliceEnd);
            setFilteredLimitedAccounts(filteredLimited);
        }
    }, [complete, incomplete, active, inactive, accounts, year, search, searchValue, limit, currentPage, pages])

    useEffect(() => {
        setSearch(false);
    }, [complete, incomplete, active, inactive, accounts, year])

    useEffect(() => {
        setCurrentPage(0);
        setGoToLast(false);
    },[complete,incomplete,active,inactive])

    const limitArray = [{ name: 10 }, { name: 20 }, { name: 40 }, { name: 60 }, { name: 80 }, { name: 100 }]

    const GetYear = (yr) => {
        var d = new Date();
        return d.getFullYear() - yr;
    }

    const checkAccountComplete = (account) => {
        var result;
        if (account.acctId === 0 && account.legalName && account.legalName !== "" && account.participantType && account.participantType !== ""
            && account.participantType !== "None" && account.location.street && account.location.street !== "" && account.location.city
            && account.location.city !== "" && account.location.state && account.location.state !== "" && account.location.zipCode
            && account.location.zipCode !== "") {
            result = true;
        }
        else {
            result = false;
        }
        return result;
    }

    const ClickFirst = () => {
        setGoToLast(false);
        setCurrentPage(0);
        setYear(yearArray[0].value);
    }

    const ClickLast = () => {
        setGoToLast(true);
        setYear(yearArray[yearArray.length - 1].value);
    }

    const ClickPrevious = () => {
        if (currentPage === 0) {
            for (var i = 0; i <= yearArray.length - 1; i++) {
                if (yearArray[i].value === year) {
                    setGoToLast(true);
                    setYear(yearArray[i - 1].value);
                }
            }
        }
        else {
            setGoToLast(false)
            setCurrentPage(currentPage - 1);
        }
    }

    const ClickNext = () => {
        if (currentPage >= (pages - 1)) {
            for (var i = 0; i <= yearArray.length - 1; i++) {
                if (yearArray[i].value === year) {
                    setGoToLast(false);
                    setYear(yearArray[i + 1].value);
                    setCurrentPage(0);
                }
            }
        }
        else {
            setGoToLast(false);
            setCurrentPage(currentPage + 1);
        }
    }

    const ChangeYear = (e) => {
        setGoToLast(false)
        setSearch(false);
        setCurrentPage(0);
        setYear(e);
    }

    const handleSearchClick = (value) => {
        setGoToLast(false);
        setActive(false)
        setInactive(false)
        setComplete(false)
        setIncomplete(false)
        setSearch(true);
        setSearchValue(value);
    }

    return (
        <>
            {loading ?
                <Loading message={<div>Loading. . . Please wait</div>} />
                :
                < Container >
                    <div style={{
                        marginTop: '5px'
                        , marginBottom: '7px'
                        // ,textAlign: 'center'
                    }}>
                        <ManuallyOnboard user={user} />
                    </div>
                    <Alert variant="info">
                        <AdminDashFilters
                            active={active} setActive={(value) => { setActive(value) }}
                            inactive={inactive} setInactive={(value) => { setInactive(value) }}
                            complete={complete} setComplete={(value) => { setComplete(value) }}
                            incomplete={incomplete} setIncomplete={(value) => {setIncomplete(value)}}
                        />
                        <AdminDashSearch
                            handleSearchClick={(value) => { handleSearchClick(value) }}
                        />
                        <hr />
                        <Row>
                            {search ?<Col className="d-flex justify-content-center">Search results for { searchValue }</Col> 
                                : <Col className="d-flex justify-content-center">Showing {filteredLength} filtered accounts created in {GetYear(year)}</Col>}
                        </Row>
                        <Row>
                            <Col className="d-flex justify-content-start">
                                <HHIEButton 
                                    id="newest-btn" 
                                    variant="primary"
                                    size="sm" 
                                    onClick={() => { ClickFirst() }}
                                    title="Newest"
                                />
                                <HHIEButton 
                                    id="oldest-btn" 
                                    variant="primary"
                                    size="sm" 
                                    onClick={() => { ClickLast() }}
                                    title="Oldest"
                                    marginl={4}
                                />
                            </Col>
                            <Col className="d-flex justify-content-center" lg="auto">
                                <ToggleButtonGroup
                                    className="table-button justify-content-center"
                                    toggle
                                    name="years"
                                    size="sm"
                                    onChange={(e) => { ChangeYear(e) }}
                                >
                                    {yearArray && yearArray.map(
                                        (radio, index) => (
                                            <ToggleButton
                                                id={index+"-year-btn" }
                                                variant="light"
                                                key={index}
                                                type="radio"
                                                name="numRadio"
                                                value={radio.value}
                                                
                                            >
                                                {GetYear(radio.value)}
                                            </ToggleButton>
                                        )
                                    )}
                                </ToggleButtonGroup>
                            </Col>
                            <Col className="d-flex justify-content-end">
                                <HHIEButton
                                    id="previous-btn"
                                    variant="primary"
                                    size="sm"
                                    disabled={yearArray[0].value === year && currentPage === 0}
                                    onClick={() => { ClickPrevious() }}
                                    title="Previous"
                                />
                                <HHIEButton
                                    id="next-btn"
                                    variant="primary"
                                    size="sm"
                                    disabled={yearArray[yearArray.length - 1].value === year && currentPage === (pages-1)}
                                    onClick={() => { ClickNext() }}
                                    title="Next"
                                    marginl={4}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col></Col><Col></Col>
                            <Col className="d-flex justify-content-center">
                                <DropdownButton
                                    className="table-button"
                                    style={{marginTop: '5px', borderRadius: '10px'}}
                                    id="dropdown-limit-button"
                                    size="sm"
                                    title={limit + " results"}
                                    variant="primary"
                                >
                                    {limitArray.map((lim, index) => (
                                        <Dropdown.Item
                                            id={index+"-limit-btn"}
                                            key={index}
                                            eventKey={lim.name}
                                            type="radio"
                                            value={lim.name}
                                            active={limit === lim.name}
                                            onSelect={() => { setLimit(lim.name) }}
                                        >
                                            {lim.name}
                                        </Dropdown.Item>
                                    ))}
                                </DropdownButton>
                            </Col>
                            <Col className="d-flex justify-content-center">
                                <div></div>
                            </Col>
                            <Col className="d-flex justify-content-end">
                                <div>page {currentPage + 1} of {pages}</div>
                            </Col>
                        </Row>
                    </Alert>
                    <AdminDashAccountsTable filteredLimitedAccounts={filteredLimitedAccounts}/>
                </Container >
            }
        </>
    );
}
